const dropdownItemWrapperClasses = '';

const dropdownItemLinkClasses = '';
const dropdownItemLinkTextClasses = '';
const dropdownItemLinkNameClasses = '';
const dropdownItemLinkDescriptionClasses = '';
const dropdownItemLinkFeaturedClasses = '';

/**
 * MobileFlyoutDropdownMenu Theme
 */

const mobileFlyoutDropdownMenuBlogTheme = {
  dropdownItemWrapperClasses,
  dropdownItemLinkClasses,
  dropdownItemLinkTextClasses,
  dropdownItemLinkNameClasses,
  dropdownItemLinkDescriptionClasses,
  dropdownItemLinkFeaturedClasses,
};

/**
 * Exports
 */

export default mobileFlyoutDropdownMenuBlogTheme;
